import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'battery_charging_areas_electric_forklift_trucks_are_close'

export const dataPointDefinition = {
  retracedId: 'battery_charging_areas_electric_forklift_trucks_are_close',
  name: 'Battery charging areas for electric forklift trucks are close to storage areas of combustible materials',
  description: 'If the facility does not have electric forklift trucks, answer Not Applicable.',
  meta: {
    slcpMeta: {
      key: 'hs-mat-23x',
      number: 'HS-MAT-6-5',
      dataType: 'array',
      masterType: 'Question',
      multiSelectKey: 'hs-mat-18',
      optionList: 'xna',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-38,Yes',
      machineShowHide: '[2],hs-38,1',
      completionCondition: 'any ms',
    },
    multiSelectKey: 'hs-mat-18',
  },
  fieldTypeId: 'MULTI_SELECT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'xna',
      name: 'xna',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'string',
          enum: ['xna'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-mat-23x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31530,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
